// example: 'thisIsATest' -> 'This Is A Test'
export const camelCaseToWords = input => {
  const withWhitespace = input.replace(/([A-Z])/g, " $1");
  return withWhitespace.charAt(0).toUpperCase() + withWhitespace.slice(1);
};
export const snakeCaseToWords = input => {
  const words = input.toLowerCase().split(/_|-/);
  return words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
};